module.exports = __webpack_public_path__ + "static/media/record-logo2.c0a1a3a6.png";